import { defaultFirmaHistorikstamdata2Columns } from "../../../../../config/firmaConfig";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../person/id/OpretNyButtonBlock";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import { FirmaDto } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useQuery } from "@apollo/client";
import { GET_FIRMA_STAMDATA_2_BY_ID_QUERY } from "../../../../../api/firma/queries";
import Spinner from "../../../../spinner/Spinner";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import { orderBy } from "../../../../../util/orderBy";

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "opretDato",
  },
];

export default function FirmaHistorikStamdata2({ id }: { id: string }) {
  const [
    firmaHistorikStamdata2Columns,
    setFirmaHistorikStamdata2ActiveColumns,
  ] = useActiveColumns(
    "firma-firmahistorikstamdata2-active-columns",
    defaultFirmaHistorikstamdata2Columns,
  );

  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "firmaHistorikStamdata2SortBy",
    {
      defaultValue: defaultSortBy,
    },
  );
  const { data, error, loading, refetch } = useQuery<{ firma: FirmaDto }>(
    GET_FIRMA_STAMDATA_2_BY_ID_QUERY(),
    { variables: { id } },
  );
  if (error) return <div>Fejl</div>;
  if (loading) return <Spinner />;
  if (!data) return null;
  const firmaHistorik = data.firma.firmahistorik2Navigation;

  if (firmaHistorik?.length === 0) {
    return <IngenRegistreringer invalidateData={refetch} />;
  }

  // event handlers
  function downloadHandler() {
    if (firmaHistorik?.length) {
      tableToXLSX(firmaHistorikStamdata2Columns, firmaHistorik, {
        fileName: `stamdata2-for-${data?.firma.firmaNr}`,
        additionalData: {
          Firmanummer: data?.firma.firmaNr,
        },
      });
    }
  }

  return (
    <ModalProvider>
      <ButtonDownload
        onClick={downloadHandler}
        isDisabled={!firmaHistorik?.length}
      />
      <TableRoot>
        <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
          <>
            {getHeaderActiveColumns(firmaHistorikStamdata2Columns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        </TableHead>
        <TableBody>
          {orderBy(
            firmaHistorik,
            sortBy.map((s) => s.field),
            sortBy.map((s) => s.direction),
          ).map((firma, i) => {
            return (
              <TableRow key={i} invalidateData={refetch}>
                <>
                  {firmaHistorikStamdata2Columns
                    .filter((col) => col.active)
                    .map((col) => {
                      return <TD key={col.field} col={col} rowData={firma} />;
                    })}
                </>
              </TableRow>
            );
          })}
        </TableBody>
      </TableRoot>
      <ColumnEditorModal
        defaultColumns={defaultFirmaHistorikstamdata2Columns}
        columns={firmaHistorikStamdata2Columns}
        setActiveColumns={setFirmaHistorikStamdata2ActiveColumns}
      />
      <OpretNyButtonBlock invalidateData={refetch} />
    </ModalProvider>
  );
}
